export const StyleUtil = {
  createInitialClassNameArray: (...classNames: string[]): string[] => [...classNames],
  mergeClassNames: (classNames: string[]): string => classNames.join(' '),
};
